import { createActions } from "../../helpers/utils/createActions";
import {
  ROLES,
} from "./actionTypes";

export const getUserRoles = createActions(ROLES.GET_ITEM)